// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/pull-refresh/index.css
// module id = 65
// module chunks = 1 2 6